import styled from 'styled-components';

export const JackpotAmountDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 75%;
    text-align: center;
    opacity: 1;
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 4px;
    
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
      font-size: 1.3rem;
      font-weight: 400;
      width: 100%;
    }
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      font-size: 1rem;
    }
`;
